﻿import Vue from "vue";
import common = require("../../common");
import context = require("../context");
import core = require("../../core");
import EditVue = require("../vue/EditVue");
import HotEditableFormAction = require("../vue/hotEditable/HotEditableFormAction");
import utilities = require("../utilities");
import FormService = require("../../services/FormService");
import SharedEmbeddedParentForm = require("../vue/hotEditable/SharedEmbeddedParentForm");
import PageService = require("../../services/PageService");

//declare function require(name: string): any;
//var jsClasses = require("../../../js/jsClasses");

interface ISettings {
    /** Valeur de l'attribut HTML "name" du formulaire contenant les champs */
    formName: string;
    /** Valeur de l'attribut HTML "id" du module Vuejs */
    vueElId: string;
    /** URL de l'API qui sera appeler lors de la sauvegarde  */
    updateApiUrl: string;
    /** Determine si le webComponent est un embeddedContent (CollapsableForm, EmbeddedForm, etc.) */
    embeddedContentModels: common.IEmbeddedContentModel[];
    /** Definie sur le mode "Edition" est constant ou s'il est "togglable" (default: false) */
    isEditionAlwaysOn?: boolean;
    /** Definie si, en mode "Edition", le formulaire doit avoir un bouton de sauvegarde ou si la sauvegarde est effectuee lors des changements de valeurs des champs (default: false) */
    liveUpdateOnEditMode?: boolean;
    liveUpdateOnEditModeIgnoredFieldNames?: string[];
    /** URL correspondant a la page precedente (doit etre definie si l'option "useBrowserHistoryToGoBackOnCancel" est activee) */
    previousPageUrl?: string;
    /** Definie si le clique du bouton Annuler ("cancel") doit faire un "Back history" ou s'il doit aller a l'API (default: true) */
    useBrowserHistoryToGoBackOnCancel?: boolean;
    /** Permet de gerer manuellement les boutons du formulaires lors des changements de mode de formulaire (original/edition). 
     * Default: TRUE */
    disableManageButtonsOnFormModeChange?: boolean;
    /** Determine si ce web component doit etre ajoute dans la liste "main.context.components" correspondant aux components loades dans la page courrante. 
     * Default: TRUE */
    appendToContextualComponents?: boolean;
    /** Determine si le formulaire inclus doit considerer le parametre 'hotform' lorsqu'il est chage (mode 'edition' ou 'original').
     * Default: TRUE */
    loadFormModeFromUrl?: boolean; /** Default: TRUE */
    /** Configurations permettant de definir des conditions afin de caracteriser un bouton de l'attribut 'disabled' (association entre un ou des boutons, et une valeur textuelle de champs). */
    disabledButtonsByDefaultFieldConfig?: common.IHotFormDisabledButtonByDefaultFieldConfig[];
    focusFirstFieldOnEdition?: boolean;
    bag?: {};
    concurrencySumCheck: string;
    // Specific
    /** Requis si 'isAddition=TRUE' */
    defaultMapaqUrl: string;
    isAddition: boolean;
}
class SommairePersonnes implements common.IWebComponent {
    private _isInit = false;
    private _formService: FormService;
    private _pageService: PageService;
    private _editVue = null as EditVue;
    private _loader = null as core.Loader;
    private _previousPageUrl: string;
    private _vueElId: string;
    private _updateApiUrl: string;
    private _liveUpdateOnEditMode: boolean;
    private _liveUpdateOnEditModeIgnoredFieldNames: string[];
    private _useBrowserHistoryToGoBackOnCancel: boolean;
    private _isEditionAlwaysOn: boolean;
    private _confirmPopup: core.ConfirmationPopup = null;
    private _customData = null as common.IPostCustomData;
    private _disabledButtonsByDefaultFieldConfig: common.IHotFormDisabledButtonByDefaultFieldConfig[];
    private _defaultMapaqUrl: string;
    private _isAddition: boolean;
    onFormActionSuccessCallback = null as (action: HotEditableFormAction, data?: common.IHotEditableFormResponseData) => void;

    init(s: ISettings) {
        if (this._isInit)
            return;
        this._isInit = true;

        // configuration
        this._updateApiUrl = s.updateApiUrl || null;
        this._vueElId = s.vueElId || (() => { throw "La propriété 'settings.vueElId' est requise."; })();
        this._isEditionAlwaysOn = s.isEditionAlwaysOn !== false;//default=TRUE
        this._liveUpdateOnEditMode = s.liveUpdateOnEditMode === true;//default is FALSE
        this._useBrowserHistoryToGoBackOnCancel = s.useBrowserHistoryToGoBackOnCancel === true;//default is FALSE
        this._disabledButtonsByDefaultFieldConfig = s.disabledButtonsByDefaultFieldConfig || [];
        this._previousPageUrl = s.previousPageUrl || null;
        // Specific
        this._isAddition = s.isAddition === true;
        this._defaultMapaqUrl = s.defaultMapaqUrl || (this._isAddition ? (() => { throw "L'argument 'defaultMapaqUrl' est requis."; })() : null);

        this._pageService = new PageService();
        this._formService = new FormService(s.formName);
        this._loader = new core.Loader(this._vueElId);
        this._confirmPopup = new core.ConfirmationPopup("#ActionConfirmPopup.mod-popup");

        this.setupVue(s);

        if (s.appendToContextualComponents !== false)
            context.components.add(this);

        return this;
    }

    getFromCustomData(key: string) {
        if (!key)
            throw "L'argument 'key' est obligatoire."
        return this._customData[key];
    }
    setToCustomData(key: string, value?: any) {
        if (!key)
            throw "L'argument 'key' est obligatoire."
        this._customData[key] = value;
        return this;
    }

    destroy() {
        this._editVue.shared.destroyComponents();
        this._editVue.$destroy();
        this._editVue = null;
    }

    private setupVue(s: ISettings) {

        Vue.prototype.$initialData = {
            vueElId: this._vueElId,
            formName: s.formName,
            bag: s.bag || null,
            loadFormModeFromUrl: s.loadFormModeFromUrl !== false,
            embeddedContentModels: s.embeddedContentModels || null,
            includesConcurrencySumCheck: true,
            concurrencySumCheck: s.concurrencySumCheck || null
        };

        this._editVue = new EditVue();

        if (s.disableManageButtonsOnFormModeChange === true)
            this._editVue.setManageButtonsOnFormModeChange(false);

        this._editVue.shared.setActionCallback(a => {
            this.onFormAction(a);
        }).setErrorCallback((errors, config) => {
            this.onFormActionError(errors, null, config);
        });
        this._editVue.shared.setupForm(this._isEditionAlwaysOn);
    }
    setSharedEmbeddedParentForm(shared: SharedEmbeddedParentForm) {
        this._editVue.shared.setSharedEmbeddedParentForm(shared);
        return this;
    }

    /** Sera appelé par le embedded field pour y injecter le navContext */
    insertNavContextHiddenField(navContextId: string) {
        utilities.insertNavContextHiddenField(this._editVue.shared.getFormName(), navContextId);
        return this;
    }
    // /** Sera appelé par le embedded field pour y injecter le sum check */
    // insertConcurrencySumCheckHiddenField(sumCheck: string) {
    //     utilities.insertConcurrencySumCheckHiddenField(this._editVue.shared.getFormName(), sumCheck);
    //     return this;
    // }

    private isCurrentlyEditingPersonne() {
        const forms = document.getElementsByTagName("form");
        for (let i = 0; i < forms.length; i++) {
            const f = forms[i];
            const embeddedFormName = this._isAddition ? "FermeAdditionAjoutPersonneForm" : "FermeAjoutPersonneForm";
            if (f.name && f.name.startsWith(embeddedFormName)) //(f.name.startsWith("FermeAdditionEditionPersonneForm_") || 
                return true;
        }
    }
    private onFormAction(action: HotEditableFormAction) {
        if (this._formService.actionHasError(action))
            return;

        utilities.disabledHotEditableButtonsByConfigurations(this._disabledButtonsByDefaultFieldConfig, this._editVue.formManager);

        const isEditionFormMode = action.isEditionFormMode();
        const actionValue = action.getActionValue();
        var actionType = action.getActionType();

        if (this._liveUpdateOnEditMode) {
            const isExcluded = utilities.any(this._liveUpdateOnEditModeIgnoredFieldNames, x => x === action.getFieldName());
            if (isExcluded)
                return;
            else if (actionType === common.HotEditableActionTypes.unknown)
                actionType = common.HotEditableActionTypes.update;
        }

        if (isEditionFormMode && actionType === common.HotEditableActionTypes.unknown)
            return;

        if (actionType === common.HotEditableActionTypes.cancel && this._useBrowserHistoryToGoBackOnCancel && this._previousPageUrl) {
            utilities.redirect(this._previousPageUrl);
            return;
        }

        const hideLoader = () => this._loader.hide();

        const f = (bypassIgnorerPersonneConfirmation?: boolean) => {
            this._loader.show();

            const post = () => {
                this._formService.validateAndPost(
                    this._updateApiUrl,
                    null,
                    {
                        posted_actionType: actionType,
                        posted_actionValue: actionValue,
                        posted_formName: this._editVue.shared.getFormName(),
                        posted_fieldName: action.getFieldOrButtonName(),
                        posted_currentCulture: context.culture.get(),
                        posted_currentUrl: utilities.currentUrl(),
                        posted_previousPageUrl: this._previousPageUrl,
                        posted_customData: utilities.ensureCustomDataIsValid(this._customData),
                        posted_currentEmbeddedComponentName: this._editVue.shared.getCurrentEmbeddedComponentName(),
                        posted_bag: this._editVue.getBagRaw(),
                        bypassIgnorerPersonneConfirmation: bypassIgnorerPersonneConfirmation === true
                    } as common.IHotEditableFormPostArguments,
                    (data: common.IHotEditableFormResponseData) => {
                        hideLoader();
                        this.onFormActionSuccess(action, data);
                    },
                    (e, config) => {
                        hideLoader();
                        this.onFormActionError(e, action, config);
                    });
            };

            if (this._liveUpdateOnEditMode)
                // NOTE: ajout d'un delai afin de permettre aux plugins de se mettre a jour.
                setTimeout(() => {
                    post();
                }, 100)
            else
                post();
        };

        if (actionType === common.HotEditableActionTypes.apply) {
            const loadAjouterPersonnePrefix = "loadAjouterPersonne:";
            if (actionValue && actionValue.startsWith(loadAjouterPersonnePrefix)) {
                const url = actionValue.replace(loadAjouterPersonnePrefix, '');
                if (!url)
                    throw "L'URL est NULL.";

                const update = () => {
                    if (this._defaultMapaqUrl) {
                        const embeddedFormName = this._isAddition ? "FermeAdditionMapaqForm" : (() => { throw "Widget MAPAQ non-supporté dans le dossier de ferme."; })();
                        this._editVue.shared.updateHotEmbeddedComponent(embeddedFormName, this._defaultMapaqUrl);
                    } this._editVue.shared.updateCurrentHotEmbeddedComponent(url);
                };
                if (this.isCurrentlyEditingPersonne())
                    this._confirmPopup.show("Attention", "Une personne est en cours de modification. En poursuivant cette opération, tout changements apportés seront annulés. Êtes-vous certain de vouloir continuer?", update);
                else
                    update();
                return;
            }
        }
        else if (actionType === common.HotEditableActionTypes.delete) {
            if (action.isButtonClick()) {
                const bn = action.getButtonName();
                if (bn === "Delete") {
                    if (this.isCurrentlyEditingPersonne()) {
                        this._confirmPopup.show("Attention", "Une personne est en cours de modification. En continuant, les changements apportés seront annulés. Êtes-vous certain de vouloir continuer?", () => {
                            f(true);
                        });
                        return;
                    }
                }
            }
        }

        f();
    }

    private onFormActionSuccess(action: HotEditableFormAction, data?: common.IHotEditableFormResponseData) {
        data = data || {};

        const actionType = action.getActionType();
        const actionValue = action.getActionValue();
        const isButtonClick = action.isButtonClick();
        const isEditionFormMode = action.isEditionFormMode();
        const isUpdateAction = actionType === common.HotEditableActionTypes.update;
        const isDeleteAction = !isUpdateAction && actionType === common.HotEditableActionTypes.delete;
        const showMessages = data.disableAllMessages !== true;
        const showAutoSuccessMessages = showMessages && data.disableAutomaticMessages !== true;
        const hasCustomMessages = data.messages && data.messages.length;
        const changedFieldName = action.getFieldName();
        const buttonClickContext = action.getButtonClickContext();

        if (data.outdatedContent) {
            const onApply = data.outdatedContent.refreshEntirePage
                ? null
                : () => {
                    if (data.outdatedContent.hotEmbeddedComponentsToRefresh)
                        this._editVue.shared.updateHotEmbeddedComponents(data.outdatedContent.hotEmbeddedComponentsToRefresh);
                    else
                        this._editVue.shared.updateCurrentHotEmbeddedComponent();
                };

            this._pageService.validateResponseDataGlobal(data, onApply);
            return;
        }

        const displayCustomMessage = (immediateDisplay: boolean, text: string, name?: string, messageType?: common.MessageTypes, autoClose?: boolean) => {
            messageType = messageType || common.MessageTypes.success//<- default is success
            if (!this._editVue.shared.displayMessage(name, text, messageType))
                this._formService.displayMessage(text, messageType, immediateDisplay, autoClose);
        }

        if (this._editVue.shared.isHotEmbeddedComponent()) {
            // Widgets -> brothers
            if (data.refreshBrotherEmbeddedComponents)
                this._editVue.refreshBrotherEmbeddedComponents();
            else if (data.restoreBrotherEmbeddedComponents)
                this._editVue.restoreBrotherEmbeddedComponents();
            else if (data.ensureBrotherEmbeddedComponentsIsDefaultUrl)
                this._editVue.ensureBrotherEmbeddedComponentsIsDefaultUrl();
            // Widgets -> all
            if (data.hotEmbeddedComponentsToUpdate && data.hotEmbeddedComponentsToUpdate.length) {
                const updateCurrentEmbededForm = utilities.any(data.hotEmbeddedComponentsToUpdate, x => !x.name);
                if (showMessages)
                    if (updateCurrentEmbededForm)
                        if (hasCustomMessages)
                            for (let i = 0; i < data.messages.length; i++) {
                                const m = data.messages[i];
                                const ac = m.autoClose === true || m.autoClose === false ? m.autoClose : true;//default=TRUE
                                displayCustomMessage(true, m.text, m.name, m.messageType, ac);
                            }
                        // if (!this._editVue.shared.displayMessage(data.messageName, data.messages, customMessageType))
                        //     this._formService.displayMessage(data.messages, customMessageType, true, true);
                        else if (showAutoSuccessMessages)
                            this._formService.displaySuccessMessageFromAction(action, true, true, this._liveUpdateOnEditMode);

                if (this._editVue && this._editVue.shared.updateHotEmbeddedComponents(data.hotEmbeddedComponentsToUpdate))
                    return;
            }
        }

        if (isDeleteAction)
            if (utilities.autoRedirect(data, this._previousPageUrl))
                return;

        this._editVue.shared.updateConcurrencySumCheck(data.updatedConcurrencySumCheck);
        this._editVue.updateBag(data.bag);

        const repost = () => this._editVue.shared.applyUpdate(actionValue, actionType, isButtonClick, buttonClickContext, changedFieldName);
        if (FormService.confirm(
            this._editVue.formManager.getFormName(),
            this._confirmPopup,
            data.confirmationMessages,
            () => {
                // Accepted
                repost();
            },
            returnToApiOnDenied => {
                // Denied

                if (returnToApiOnDenied) {
                    repost();
                    return;
                }
                if (this._editVue.shared.confirmationRejected())
                    this._formService.displayNotSavedErrorMessageImediately();
            }))
            return;

        if (isUpdateAction || data.redirectUrl) {
            const url = data.redirectUrl || this._previousPageUrl || null;
            if (url) {
                if (showMessages)
                    if (hasCustomMessages)
                        for (let i = 0; i < data.messages.length; i++) {
                            const m = data.messages[i];
                            const ac = m.autoClose === true || m.autoClose === false ? m.autoClose : true;//default=TRUE
                            displayCustomMessage(false, m.text, m.name, m.messageType, ac);
                        }
                    // if (!this._editVue.shared.displayMessage(data.messageName, data.messages, customMessageType))
                    //     this._formService.displayMessage(data.messages, customMessageType, false, true);
                    else if (showAutoSuccessMessages)
                        this._formService.displaySuccessMessageFromAction(action, false, true, this._liveUpdateOnEditMode);
                utilities.redirectWithOptions(url, data.redirectUrlOptions);
                return;
            }
        }

        if (data.fieldsToUpdate)
            for (let i = 0; i < data.fieldsToUpdate.length; i++) {
                const updatedField = data.fieldsToUpdate[i];
                if (updatedField)
                    this._editVue.shared.updateFieldFromApi(updatedField);
            }

        if (showMessages)
            if (hasCustomMessages)
                for (let i = 0; i < data.messages.length; i++) {
                    const m = data.messages[i];
                    const ac = m.autoClose === true || m.autoClose === false ? m.autoClose : true;//default=TRUE
                    displayCustomMessage(true, m.text, m.name, m.messageType, ac);
                }
            // if (!this._editVue.shared.displayMessage(data.messageName, data.messages, customMessageType))
            //     this._formService.displayMessage(data.messages, customMessageType, true, true);
            else if (showAutoSuccessMessages)
                this._formService.displaySuccessMessageFromAction(action, true, true, this._liveUpdateOnEditMode);

        if (isEditionFormMode && !this._isEditionAlwaysOn && !this._liveUpdateOnEditMode)
            this._editVue.shared.setAsHotEditableFormMode();
    }

    private onFormActionError(errors: common.IError[], action?: HotEditableFormAction, config?: common.IHotEditableFormConfig) {
        config = config || {};

        for (let i = 0; i < errors.length; i++) {
            const error = errors[i];

            if (error.code !== 110) {

                if (context.env.currentIsDev || context.env.currentIsLocal) {
                    utilities.printError(error.message + ' (code: ' + error.code + ')');
                    this._formService.displayErrorImediately(new core.Error("Une erreur système est survenue et est affichée dans la console du navigateur.", error.code));
                }
                else
                    this._formService.displayErrorImediately(new core.Error(error.message));

                return;
            }

            if (config.disableAutomaticMessages)
                return;

            // Functional
            const fieldFound = this._editVue.shared.displayFieldError(this._editVue.shared.getFormName(), error, true);
            if (fieldFound) {
                this._formService.displayNotSavedErrorMessageImediately();
                return;
            }

            this._formService.displayErrorImediately(new core.Error(error.message));
        }
    }
}

export = SommairePersonnes;